import { Box, Layer } from 'grommet';
import React from 'react';

import { Prompt } from '@/components/prompt';
import { Alert, AlertBody, AlertTitle } from '@/components-new/alert';
import { Text } from '@/components-new/text';
import { User } from '@/features/admin/types/user';
import { Client } from '@/features/clients';
import { useDeleteClientUser } from '@/features/clients/api/use-delete-client-user';
import { isUserPrimaryAdmin } from '@/features/clients/clients-utils';

type Props = {
  user: User,
  client: Client,
  onClose: () => void;
}
const DeleteClientUserPrompt = ({ client, user, onClose }: Props) => {
  const {
    mutate: deleteUser,
    isPending,
  } = useDeleteClientUser();

  const handleConfirm = () => {
    deleteUser(
      { clientId: client.id, userId: user.id },
      {
        onSuccess: () => {
          onClose();
        }
      }
    );
  };

  return (
    <Layer onClickOutside={onClose}>
      <Prompt
        header="Delete User"
        actions={[
          { name: 'Cancel', onClick: onClose, variant: 'outlined' },
          { name: 'Delete', onClick: handleConfirm, disabled: () => isPending, variant: 'danger' },
        ]}
      >
        {isUserPrimaryAdmin(user, client) && (
          <Box margin={{ bottom: 'small' }}>
            <Alert variant="critical">
              <AlertTitle>
                {`This user is the primary admin for ${client.name}.`}
              </AlertTitle>
              <AlertBody>
                Deleting this user will unset the primary administrator. Be sure
                to set a new primary administrator when you are done.
              </AlertBody>
            </Alert>
          </Box>
        )}
        <Text>
          Are you sure you want to delete <strong>{user.name}</strong>?
        </Text>
      </Prompt>
    </Layer>
  );
};

export default DeleteClientUserPrompt;
